<template>
	<div class="maintenance-detail">
		<div class="maintenance-container">
			<div class="maintenance-content">
				<!-- <div class="moudleDefaultTitle">资质材料维护</div> -->

				<div class="maintenance-box">
					<!-- 卡片式表单--start -->
					<div class="form-card-container">
						<div class="form-card-header">
							<span>{{ certTypeName }}资质材料维护</span>
						</div>
						<div class="form-card-content">
							<!-- 根据sslCode动态渲染对应组件 -->
							<component :is="getComponentBySslCode" :is-setting="true" :ssl-code="sslCode"></component>
							<!-- <safety-permit-maintenance :is-setting="true"></safety-permit-maintenance> -->
						</div>
					</div>
					<!-- 卡片式表单--end -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SafetyPermitMaintenance from './materialsRecord/safetyPermitMaintenance'
	import ConstructionEnterpriseMaintenance from './materialsRecord/constructionEnterpriseMaintenance'
	import EngineeringSupervisionMaintenance from './materialsRecord/engineeringSupervisionMaintenance'
	import RealEstateDevelopmentMaintenance from './materialsRecord/realEstateDevelopmentMaintenance'
	import { ENUM_CERT_STATE } from '@/enum/index'

	// 资质维护详情
	export default {
		name: 'MaintenanceDetail',
		components: {
			SafetyPermitMaintenance,
			ConstructionEnterpriseMaintenance,
			EngineeringSupervisionMaintenance,
			RealEstateDevelopmentMaintenance
		},
		props: {},
		data() {
			return {
				// 当前维护资质材料资质证书编码
				sslCode: ''
			}
		},
		computed: {
			// 根据sslCode获取对应的资质类型名称
			certTypeName() {
				return ENUM_CERT_STATE[this.sslCode] || '未知类型'
			},
			// 通过sslCode判断渲染那个证书的材料维护组件
			getComponentBySslCode() {
				// 组件映射表
				const componentMap = {
					// 建筑业
					'107': 'ConstructionEnterpriseMaintenance',
					// 安许
					'109': 'SafetyPermitMaintenance',
					// 工程监理
					'106': 'EngineeringSupervisionMaintenance',
					// 房地产开发
					'111': 'RealEstateDevelopmentMaintenance'
				}

				// 根据sslCode获取对应的组件名，不存在则返回默认组件
				return componentMap[this.sslCode] || 'SafetyPermitMaintenance'
			}
		},
		watch: {},
		// 添加路由守卫
		beforeRouteEnter(to, from, next) {
			// 获取路由参数中的sslCode
			const sslCode = to.params.sslCode || ''
			if (!sslCode) {
				// 使用next回调，因为此时组件实例还未被创建
				next(vm => {
					// vm.$message.error('证书编码不能为空')
					setTimeout(() => {
						vm.$router.push({ path: '/qualification/maintenance' })
					}, 1500)
				})
				return
			}

			// 检查sslCode是否在ENUM_CERT_STATE中
			const isValidCode = Object.keys(ENUM_CERT_STATE).includes(sslCode)

			if (!isValidCode) {
				next(vm => {
					// vm.$message.error('无效的证书编码')
					setTimeout(() => {
						vm.$router.push({ path: '/qualification/maintenance' })
					}, 1500)
				})
				return
			}

			// sslCode有效，允许进入页面
			next(vm => {
				// 设置组件的sslCode
				vm.sslCode = sslCode
			})
		},
		created() {
			console.log('this.$route:', this.$route)
			console.log('this.$route.params:', this.$route.params.sslCode)

			// 如果路由守卫没有设置sslCode（可能是直接刷新页面），则在这里设置
			if (!this.sslCode) {
				this.sslCode = this.$route.params.sslCode || ''
			}
		},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.maintenance-detail {
		.maintenance-container {
			background-color: #eaf2f7;
			padding: 20px 0 40px;
			.maintenance-content {
				width: $main-page-width;
				margin: 0 auto;

				.maintenance-box {
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;
				}

				.form-card-container {
					// border: 1px solid #0c72fe;
					// border-top-left-radius: 6px;
					// border-top-right-radius: 6px;

					.form-card-header {
						background-color: #4686d2;
						color: white;
						padding: 12px 20px;
						font-size: 16px;
						font-weight: 500;
						text-align: center;
					}

					.form-card-content {
						padding: 10px 0;
						border-top: none;
						font-size: 16px;
					}
				}

				.maintenance-footer {
					text-align: center;
					margin: 20px 0;
				}
			}
		}
	}
</style>
